module.exports = __webpack_public_path__ + "img/excel.a71b0894.svg";